import _parseFloat from "@babel/runtime-corejs3/core-js/parse-float";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { useAssetFieldVisibility } from "@Client/@Composables/application-standalone/pages/assets/useAssetFieldVisibility";
import { useBindApplication } from "@Client/@Composables/application-standalone/useBindApplication";
import { APPLICATION_PATH } from "@Client/@Utils/enums/application-paths";
import i18n from "@Shared/@i18n";
import { formatMoneyValueLong } from "@Shared/@Utils/helpers/money";
import { computed, ref } from "@vue/composition-api";
export const useAssetHelpers = () => {
  const {
    addNestedField,
    removeNestedField
  } = useBindApplication();
  const {
    applicantsAsOptions: applicantsAsOptionsFromHelper,
    applicationHasCoApplicants,
    isApplicantVisibleFromFillOut
  } = useApplicantHelpers();
  const addEmptyAsset = applicantIndex => {
    const rootPath = applicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : APPLICATION_PATH.CO_APPLICANTS + `[${applicantIndex - 1}]`;
    addNestedField(rootPath + "[assets]");
  };
  const deleteAsset = (applicantIndex, assetIndex) => {
    const rootPath = applicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : APPLICATION_PATH.CO_APPLICANTS + `[${applicantIndex - 1}]`;
    removeNestedField(rootPath + "[assets]", assetIndex);
  };
  const assetSummarySubtitle = asset => {
    var _asset$amount;
    const assetInfo = [];
    if (asset.type) assetInfo.push(i18n.t(`application-form.${asset.type}`).toString());
    const amount = (_asset$amount = asset.amount) == null ? void 0 : _asset$amount.toString();
    if (_parseFloat(amount)) assetInfo.push(formatMoneyValueLong(amount));
    return assetInfo.join(" | ");
  };
  const applicantHasAssets = assets => (assets == null ? void 0 : assets.length) > 0;
  const isAssetSectionVisibleForMainApplicant = computed(() => {
    const {
      isAssetSectionVisibleForApplicant
    } = useAssetFieldVisibility({
      applicantIndex: ref(0),
      assetIndex: ref(0)
    });
    return isAssetSectionVisibleForApplicant.value;
  });
  const isAssetSectionVisibleForCoApplicants = computed(() => {
    if (!applicationHasCoApplicants.value) return false;
    const {
      isAssetSectionVisibleForApplicant
    } = useAssetFieldVisibility({
      applicantIndex: ref(1),
      assetIndex: ref(0)
    });
    return isAssetSectionVisibleForApplicant.value;
  });
  const filteredApplicantsAsOptions = computed(() => {
    const [mainApplicant, ...coApplicants] = applicantsAsOptionsFromHelper.value;
    const filteredApplicants = [];
    if (isAssetSectionVisibleForMainApplicant.value) filteredApplicants.push(mainApplicant);
    if (isAssetSectionVisibleForCoApplicants.value) filteredApplicants.push(...coApplicants);
    return _filterInstanceProperty(filteredApplicants).call(filteredApplicants, ({
      id
    }) => isApplicantVisibleFromFillOut(id));
  });
  return {
    addEmptyAsset,
    deleteAsset,
    assetSummarySubtitle,
    applicantHasAssets,
    filteredApplicantsAsOptions,
    isAssetSectionVisibleForMainApplicant,
    isAssetSectionVisibleForCoApplicants
  };
};